import { atom, createStore } from 'jotai'

export type UserMessageType =
    | { type: 'success' | 'warning'; message: string }
    | { type: 'error'; message: string; errorCode: string | number | null }
    | null

export const userMessageAtom = atom<UserMessageType>(null)
export const userMessageStore = createStore()
